// JsFromRoutes CacheKey 7c537c6721b296528d64c2237fcf821e
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/broker/prospects'),
  new: /* #__PURE__ */ definePathHelper('get', '/broker/prospects/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/broker/prospects/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/broker/prospects/:id'),
}
